import { render, staticRenderFns } from "./XLviewer.vue?vue&type=template&id=e3d85ee8&scoped=true&"
import script from "./XLviewer.vue?vue&type=script&lang=js&"
export * from "./XLviewer.vue?vue&type=script&lang=js&"
import style0 from "./XLviewer.vue?vue&type=style&index=0&id=e3d85ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d85ee8",
  null
  
)

export default component.exports